export const LEGAL_DOCS_AR = {
  privacy: {
    title: "سياسة الخصوصية",
    path: "/privacy-policy",
    sections: [
      {
        heading: "1. مقدمة",
        paragraphs: [
          "VCK Business Lab (\"VCK\"، \"نحن\"، \"لنا\") هي شركة دعم أعمال افتراضي مقرها إدمونتون، ألبرتا، كندا، وتخدم العملاء في كندا ودوليًا. توضح سياسة الخصوصية هذه كيفية جمعنا للمعلومات الشخصية واستخدامها والإفصاح عنها والاحتفاظ بها وحمايتها أثناء تشغيل موقعنا الإلكتروني وتقديم خدماتنا.",
          "تم إعداد هذه السياسة وفقًا لمبادئ قانون حماية المعلومات الشخصية في ألبرتا (PIPA). إذا كنت خارج ألبرتا، فقد تنطبق أيضًا قوانين خصوصية إلزامية إضافية في ولايتك القضائية، ولا يهدف أي شيء في هذه السياسة إلى استبعاد الحقوق التي لا يمكن التنازل عنها قانونًا.",
        ],
      },
      {
        heading: "2. المعلومات الشخصية التي قد نجمعها",
        bullets: [
          "معلومات الاتصال — الاسم، عنوان البريد الإلكتروني، رقم الهاتف، اسم الشركة، البلد، وطريقة الاتصال المفضلة.",
          "معلومات الاستفسارات وعروض الأسعار — التفاصيل التي تشاركها في نماذج الاتصال وطلبات عروض الأسعار وحجوزات الاستشارات والمراسلات، بما في ذلك نوع الدعم الذي تبحث عنه.",
          "معلومات العملاء والمشاريع — المستندات والتعليمات وتفاصيل المشاريع والمواد الأخرى التي تقدمها حتى نتمكن من تقديم الخدمات.",
          "معلومات الفواتير والدفع — مراجع الفواتير ومبالغ المدفوعات وسجلات المعاملات. تتم معالجة أرقام البطاقات من قبل مزود الدفع لدينا (Stripe) ولا تُخزَّن أبدًا على خوادمنا.",
          "معلومات استخدام الموقع والمعلومات التقنية — مثل الصفحات التي تمت زيارتها ونوع المتصفح والجهاز والموقع التقريبي والصفحات المحيلة.",
        ],
      },
      {
        heading: "3. ملفات تعريف الارتباط والتحليلات",
        paragraphs: [
          "يستخدم موقعنا الإلكتروني عددًا قليلاً من ملفات تعريف الارتباط — على سبيل المثال، لتذكر تفضيل اللغة الخاص بك — وقد يستخدم تحليلات تراعي الخصوصية لفهم كيفية استخدام الموقع. يرجى الاطلاع على سياسة ملفات تعريف الارتباط للحصول على التفاصيل وكيفية التحكم فيها عبر إعدادات المتصفح.",
        ],
      },
      {
        heading: "4. لماذا نجمع المعلومات",
        bullets: [
          "للرد على الاستفسارات وإعداد عروض الأسعار.",
          "لجدولة الاستشارات والخدمات وتقديمها.",
          "لإدارة علاقات العملاء والمشاريع والفواتير والمدفوعات.",
          "لإرسال اتصالات متعلقة بالخدمة، مثل تأكيدات الحجز وتذكيرات المواعيد.",
          "لتحسين موقعنا الإلكتروني وخدماتنا وتجربة العملاء.",
          "للوفاء بالالتزامات القانونية والمحاسبية والاحتفاظ بالسجلات.",
        ],
      },
      {
        heading: "5. الموافقة",
        paragraphs: [
          "بإرسال استفسار أو حجز استشارة أو الاستعانة بخدماتنا، فإنك توافق على جمع معلوماتك الشخصية واستخدامها والإفصاح عنها كما هو موضح في هذه السياسة. يمكنك سحب موافقتك في أي وقت عن طريق التواصل معنا، مع مراعاة القيود القانونية والتعاقدية؛ وقد يحد سحب الموافقة من قدرتنا على تقديم الخدمات لك.",
        ],
      },
      {
        heading: "6. الاستخدام والإفصاح",
        paragraphs: [
          "نستخدم المعلومات الشخصية فقط للأغراض الموضحة أعلاه أو لأغراض متوافقة معها. نحن لا نبيع المعلومات الشخصية. نفصح عن المعلومات الشخصية فقط حسب الحاجة لتقديم خدماتنا، أو كما هو موضح في هذه السياسة، أو كما يقتضيه القانون أو يسمح به.",
        ],
      },
      {
        heading: "7. مزودو الخدمات والمقاولون من الباطن",
        paragraphs: [
          "قد نعمل مع مزودي خدمات ومقاولين من الباطن موثوقين (على سبيل المثال، مترجمين أو متخصصين إداريين أو مساعدين تقنيين) يساعدون في تنفيذ مشروعك. يُمنحون حق الوصول فقط إلى المعلومات اللازمة لعملهم ويُتوقع منهم حمايتها بموجب التزامات السرية.",
        ],
      },
      {
        heading: "8. مزودو السحابة والبرمجيات",
        paragraphs: [
          "نستخدم مزودي خدمات سحابية وبرمجيات ذوي سمعة طيبة للبريد الإلكتروني والجدولة وتخزين الملفات وإدارة المشاريع ومعالجة المدفوعات واستضافة المواقع الإلكترونية. قد تتم معالجة معلوماتك من قبل مزودي التكنولوجيا الخارجيين هؤلاء نيابة عنا، وفقًا لممارسات الأمان والخصوصية الخاصة بهم.",
        ],
      },
      {
        heading: "9. المعالجة الدولية للبيانات",
        paragraphs: [
          "نظرًا لأننا نعمل افتراضيًا ونخدم عملاء دوليين، فقد تتم معالجة معلوماتك من قبل مزودي تكنولوجيا خارجيين وقد تُخزَّن خارج مقاطعتك أو بلدك، بما في ذلك في الولايات المتحدة أو ولايات قضائية أخرى، حيثما يسمح القانون بذلك. قد تخضع المعلومات المخزنة في ولاية قضائية أخرى لقوانين تلك الولاية.",
        ],
      },
      {
        heading: "10. أمن المعلومات",
        paragraphs: [
          "نستخدم ضمانات إدارية وتقنية ومادية معقولة تتناسب مع حساسية المعلومات — بما في ذلك ضوابط الوصول والمنصات الآمنة وممارسات السرية. ومع ذلك، لا توجد طريقة نقل أو تخزين آمنة تمامًا، ولا يمكننا ضمان الأمن المطلق للبيانات.",
        ],
      },
      {
        heading: "11. معلومات العملاء السرية",
        paragraphs: [
          "تُعامل مواد العملاء ومعلومات الأعمال وتفاصيل المشاريع على أنها سرية، وتُستخدم فقط لتقديم خدماتك، وتُشارك فقط مع الأشخاص والمزودين المشاركين في تعاقدك، أو كما يقتضيه القانون.",
        ],
      },
      {
        heading: "12. الاحتفاظ والحذف الآمن",
        paragraphs: [
          "نحتفظ بالمعلومات الشخصية فقط طالما كانت مطلوبة للأغراض التي جُمعت من أجلها، وللوفاء بالمتطلبات القانونية أو المحاسبية أو التعاقدية. عندما لم تعد هناك حاجة إليها، تُحذف المعلومات أو تُتلف بشكل آمن.",
        ],
      },
      {
        heading: "13. طلبات الوصول والتصحيح",
        paragraphs: [
          "يمكنك طلب الوصول إلى معلوماتك الشخصية، أو مطالبتنا بتصحيحها، عن طريق التواصل معنا على العنوان أدناه. سنرد في غضون فترة معقولة ووفقًا للقانون المعمول به.",
        ],
      },
      {
        heading: "14. شكاوى الخصوصية",
        paragraphs: [
          "إذا كانت لديك مخاوف بشأن كيفية تعاملنا مع المعلومات الشخصية، يرجى التواصل معنا أولاً حتى نتمكن من محاولة حلها. إذا لم تكن راضيًا، يمكنك التواصل مع مكتب مفوض المعلومات والخصوصية في ألبرتا.",
        ],
      },
      {
        heading: "15. الحوادث الأمنية وتسرب البيانات",
        paragraphs: [
          "إذا أحدثت حادثة أمنية خطرًا حقيقيًا بضرر جسيم، فسنخطر الأفراد المتأثرين والجهة التنظيمية المختصة كما يقتضي القانون المعمول به، وسنتخذ خطوات معقولة لتقليل خطر الضرر.",
        ],
      },
      {
        heading: "16. مسؤول الخصوصية",
        paragraphs: [
          "مسؤول الخصوصية هو المسؤول عن أسئلة الخصوصية وطلبات الوصول والتصحيح والشكاوى والاستجابة لحوادث الخصوصية. يمكنك التواصل مع مسؤول الخصوصية على:",
          "مسؤول الخصوصية، VCK Business Lab، إدمونتون، ألبرتا، كندا — office@vckbusinesslab.com",
        ],
      },
      {
        heading: "17. الاتصالات التسويقية (CASL)",
        paragraphs: [
          "قد ترسل VCK Business Lab رسائل إلكترونية تجارية فقط حيثما يسمح القانون المعمول به بذلك، بما في ذلك القانون الكندي لمكافحة البريد العشوائي (CASL). حيثما يلزم، تحصل VCK على الموافقة قبل إرسال الاتصالات الترويجية.",
          "ستحدد الرسائل التجارية من VCK هوية VCK Business Lab، وتتضمن معلومات اتصال صالحة، وتوفر آلية إلغاء اشتراك فعالة. يمكنك سحب موافقتك على تلقي الاتصالات التسويقية في أي وقت، وتُعالج طلبات إلغاء الاشتراك على الفور وضمن الفترة التي يقتضيها القانون.",
          "بعد طلب إلغاء الاشتراك، قد نحتفظ بمعلومات حظر محدودة للمساعدة في ضمان عدم إعادة إضافتك عن غير قصد إلى قوائم التسويق.",
        ],
      },
      {
        heading: "18. التغييرات على هذه السياسة",
        paragraphs: [
          "قد نحدّث سياسة الخصوصية هذه من وقت لآخر. ستُنشر النسخة الحالية دائمًا على هذه الصفحة مع تاريخ \"آخر تحديث\".",
        ],
      },
      {
        heading: "19. جهة اتصال الخصوصية",
        paragraphs: [
          "يمكن إرسال أسئلة الخصوصية وطلبات الوصول أو التصحيح والشكاوى إلى office@vckbusinesslab.com. يقع مقر VCK Business Lab في إدمونتون، ألبرتا، كندا.",
        ],
      },
    ],
  },
  terms: {
    title: "شروط استخدام الموقع الإلكتروني",
    path: "/terms-of-use",
    sections: [
      {
        heading: "1. قبول هذه الشروط",
        paragraphs: [
          "بالوصول إلى موقع VCK Business Lab الإلكتروني أو استخدامه، فإنك تقبل شروط استخدام الموقع الإلكتروني هذه. إذا كنت لا توافق، يرجى عدم استخدام الموقع الإلكتروني.",
        ],
      },
      {
        heading: "2. الغرض المعلوماتي",
        paragraphs: [
          "يُقدَّم هذا الموقع الإلكتروني لأغراض معلوماتية عامة حول VCK Business Lab وخدماتها. لا يشكل محتوى الموقع عرضًا قابلاً للقبول، وتُبرم تعاقدات الخدمات فقط من خلال عرض سعر مكتوب أو اتفاقية خدمات أو بيان عمل أو تأكيد حجز.",
        ],
      },
      {
        heading: "3. لا مشورة مهنية",
        paragraphs: [
          "لا يشكل أي شيء على هذا الموقع الإلكتروني مشورة مهنية من أي نوع — بما في ذلك المشورة القانونية أو المحاسبية أو الضريبية أو المتعلقة بالهجرة أو الطبية أو الهندسية. لا تقدم VCK Business Lab خدمات هندسية مهنية أو مشورة قانونية أو مشورة محاسبية أو ضريبية أو مشورة هجرة أو مشورة طبية، ولا ينبغي الاعتماد على محتوى الموقع على هذا النحو.",
        ],
      },
      {
        heading: "4. لا تنشأ علاقة عميل",
        paragraphs: [
          "إن استخدام هذا الموقع الإلكتروني أو إرسال استفسار أو حجز استشارة أو تلقي رد لا ينشئ علاقة عميل. تبدأ علاقة العميل فقط عندما يتم قبول عرض سعر مكتوب أو اتفاقية خدمات أو بيان عمل أو تأكيد حجز من قبل الطرفين.",
        ],
      },
      {
        heading: "5. الملكية الفكرية",
        paragraphs: [
          "محتوى هذا الموقع الإلكتروني — بما في ذلك النص والتصميم والرسومات والشعارات والتخطيط — مملوك لـ VCK Business Lab أو مرخص لها ومحمي بموجب قوانين الملكية الفكرية المعمول بها. يمكنك عرض الموقع ومشاركة روابطه، ولكن لا يجوز لك نسخ محتواه أو إعادة إنتاجه أو إعادة نشره لأغراض تجارية دون إذن كتابي.",
        ],
      },
      {
        heading: "6. الاستخدام المسموح والمحظور",
        paragraphs: [
          "يجوز لك استخدام هذا الموقع الإلكتروني للأغراض المشروعة فقط. توافق على عدم إساءة استخدام الموقع، أو محاولة الوصول غير المصرح به إلى أي جزء منه أو إلى أنظمته، أو جمع المعلومات بشكل جماعي، أو تقديم معلومات كاذبة أو مضللة، أو التدخل في تشغيل الموقع، أو استخدام الموقع بأي طريقة تنتهك القانون المعمول به.",
        ],
      },
      {
        heading: "7. دقة المعلومات",
        paragraphs: [
          "نعمل على إبقاء معلومات الموقع دقيقة وحديثة، لكننا لا نضمن أن يكون كل المحتوى كاملاً أو دقيقًا أو محدثًا في جميع الأوقات. قد تتغير أوصاف الخدمات والتوفر والأسعار.",
        ],
      },
      {
        heading: "8. الأسعار",
        paragraphs: [
          "الأسعار المعروضة على هذا الموقع الإلكتروني هي أسعار ابتدائية أو استرشادية فقط، ما لم يتم تأكيدها في عرض سعر مكتوب أو اتفاقية لمشروعك المحدد. تعتمد الأسعار النهائية على النطاق والتعقيد والحجم والاستعجال والشروط المتفق عليها كتابيًا.",
        ],
      },
      {
        heading: "9. روابط وخدمات الطرف الثالث",
        paragraphs: [
          "يرتبط هذا الموقع الإلكتروني بخدمات طرف ثالث أو يتكامل معها، مثل الجدولة (Cal.com) ومعالجة المدفوعات (Stripe) والمراسلة (WhatsApp). نحن لا نتحكم في مواقع وخدمات الطرف الثالث ولسنا مسؤولين عن محتواها أو ممارسات الخصوصية الخاصة بها.",
        ],
      },
      {
        heading: "10. التوفر والانقطاعات",
        paragraphs: [
          "نهدف إلى إبقاء الموقع الإلكتروني متاحًا، لكنه قد ينقطع أو يصبح غير متاح من وقت لآخر — للصيانة أو التحديثات أو المشكلات التقنية أو لأسباب خارجة عن سيطرتنا — دون إشعار.",
        ],
      },
      {
        heading: "11. تحديد المسؤولية",
        paragraphs: [
          "إلى أقصى حد يسمح به القانون المعمول به، لا تتحمل VCK Business Lab المسؤولية عن أي أضرار غير مباشرة أو عرضية أو تبعية أو خاصة تنشأ عن استخدام هذا الموقع الإلكتروني أو محتواه أو عدم القدرة على استخدامه. لا يستبعد أي شيء في هذه الشروط أو يحد من المسؤولية التي لا يمكن استبعادها أو تقييدها قانونًا.",
        ],
      },
      {
        heading: "12. التعويض",
        paragraphs: [
          "إلى الحد الذي يسمح به القانون، توافق على تعويض VCK Business Lab وإبراء ذمتها من المطالبات أو الخسائر أو النفقات الناشئة عن إساءة استخدامك لهذا الموقع الإلكتروني أو خرقك لهذه الشروط.",
        ],
      },
      {
        heading: "13. التغييرات على الموقع الإلكتروني أو هذه الشروط",
        paragraphs: [
          "قد نحدّث الموقع الإلكتروني وهذه الشروط من وقت لآخر. ستُنشر النسخة الحالية على هذه الصفحة مع تاريخ \"آخر تحديث\"، ويعني استمرارك في استخدام الموقع قبولك للشروط المحدثة.",
        ],
      },
      {
        heading: "14. القانون الحاكم",
        paragraphs: [
          "تخضع هذه الشروط لقوانين مقاطعة ألبرتا والقوانين الفيدرالية الكندية المعمول بها فيها. إذا وصلت إلى هذا الموقع الإلكتروني من ولاية قضائية أخرى، فقد تنطبق أيضًا القوانين المحلية الإلزامية لتلك الولاية، ولا يهدف أي شيء في هذه الشروط إلى تجاوز الحقوق التي لا يمكن التنازل عنها قانونًا.",
        ],
      },
    ],
  },
  service: {
    title: "شروط الخدمة وإخلاء المسؤولية العام",
    path: "/service-terms",
    sections: [
      {
        heading: "1. كيف تبدأ التعاقدات",
        paragraphs: [
          "تتطلب جميع خدمات VCK Business Lab قبول عرض سعر أو اتفاقية خدمات أو بيان عمل أو تأكيد حجز أو أي اتفاقية كتابية أخرى قبل بدء العمل. لا ينشئ أي شيء على هذا الموقع الإلكتروني — بما في ذلك أوصاف الخدمات والأسعار المدرجة — تعاقدًا بحد ذاته.",
        ],
      },
      {
        heading: "2. النطاق والمواعيد النهائية والرسوم",
        paragraphs: [
          "جميع الخدمات خاضعة للتوفر. يعتمد النطاق والمخرجات والمواعيد النهائية وجولات المراجعة والرسوم على المشروع الفردي وتُحدد في عرض السعر المكتوب أو الاتفاقية الخاصة بذلك التعاقد. تتقدم شروط الاتفاقية الموقعة على معلومات الموقع الإلكتروني العامة.",
        ],
      },
      {
        heading: "3. معلومات ومواد العميل",
        paragraphs: [
          "العميل مسؤول عن تقديم معلومات وتعليمات ومواد كاملة ودقيقة وفي الوقت المناسب. يجوز لـ VCK الاعتماد على المعلومات والمواد المقدمة من العميل وليست مسؤولة عن الأخطاء في العمل النهائي الناتجة عن معلومات غير دقيقة أو غير كاملة قدمها العميل.",
        ],
      },
      {
        heading: "4. تأخيرات العميل",
        paragraphs: [
          "تفترض المواعيد النهائية التواصل والموافقات في الوقت المناسب من العميل. قد تؤثر تأخيرات العميل — مثل التأخر في الملاحظات أو نقص المواد أو الموافقات المؤجلة — على المواعيد النهائية وتواريخ التسليم بشكل مماثل.",
        ],
      },
      {
        heading: "5. لا نتائج مضمونة",
        paragraphs: [
          "لا تضمن VCK Business Lab نتائج أعمال محددة، بما في ذلك المبيعات أو الإيرادات أو الأرباح أو تصنيفات محركات البحث أو حركة مرور الموقع الإلكتروني أو اكتساب العملاء أو القبول التنظيمي للمستندات أو غيرها من النتائج. نلتزم بعمل مهني ومجتهد — وليس بنتائج محددة تعتمد على عوامل كثيرة خارجة عن سيطرتنا.",
        ],
      },
      {
        heading: "6. التصحيحات",
        paragraphs: [
          "إذا ارتكبت VCK خطأً جوهريًا في الخدمة، يرجى إخبارنا على الفور. مع مراعاة القانون المعمول به، يجب منح VCK فرصة معقولة لتصحيح أو إعادة أداء العمل المتأثر قبل اللجوء إلى سبل انتصاف أخرى.",
        ],
      },
      {
        heading: "7. خدمات الطرف الثالث",
        paragraphs: [
          "إن برامج الطرف الثالث ومزودي الاستضافة ومسجلي النطاقات والإضافات ومنصات الدفع وأدوات الجدولة والخدمات المماثلة خارجة عن السيطرة المباشرة لـ VCK. نحن لسنا مسؤولين عن انقطاعات أو تغييرات أو فقدان بيانات أو تغييرات أسعار أو توقف خدمات الطرف الثالث، رغم أننا سنبذل جهودًا معقولة لمساعدتك على التكيف.",
        ],
      },
      {
        heading: "8. المراجعة والموافقة",
        paragraphs: [
          "العميل مسؤول عن مراجعة والموافقة على المحتوى النهائي والمستندات والترجمات ومواد الموقع الإلكتروني قبل النشر أو الاستخدام. بمجرد موافقة العميل أو النشر، تقع مسؤولية استخدام المادة النهائية على العميل.",
        ],
      },
      {
        heading: "9. العلاقة بالاتفاقيات الموقعة",
        paragraphs: [
          "تُكمّل شروط الخدمة هذه — ولا تحل محل — أي اتفاقية خدمات رئيسية أو عرض سعر موقع أو جدول خدمات أو بيان عمل بينك وبين VCK Business Lab. في حالة وجود تعارض، تسود الاتفاقية الموقعة.",
        ],
      },
    ],
  },
  translation: {
    title: "إخلاء مسؤولية الترجمة التحريرية والشفوية",
    path: "/translation-disclaimer",
    sections: [
      {
        heading: "1. خدمات لغوية عامة وتجارية",
        paragraphs: [
          "الخدمات اللغوية القياسية المعلن عنها علنًا من VCK Business Lab هي الترجمة التحريرية والشفوية العامة والتجارية — للتواصل التجاري اليومي والاجتماعات والمستندات والتعامل مع العملاء والمواقع الإلكترونية والعروض التقديمية والأغراض غير المنظمة المماثلة.",
        ],
      },
      {
        heading: "2. مسؤوليتك عن توضيح الاستخدام المقصود",
        paragraphs: [
          "أنت مسؤول عن إخبارنا بالاستخدام المقصود للترجمة وأي متطلبات للجهة المستلمة قبل بدء العمل، حتى نتمكن من تأكيد ما إذا كان العمل ضمن نطاقنا.",
        ],
      },
      {
        heading: "3. ليست معتمدة ما لم يُذكر صراحة",
        paragraphs: [
          "لا ينبغي اعتبار الترجمات العامة تلقائيًا مستندات معتمدة أو محلفة أو قانونية أو مقبولة رسميًا. لا تقدم VCK Business Lab خدماتها القياسية للترجمة التحريرية أو الشفوية على أنها معتمدة أو محلفة أو معتمدة قضائيًا أو قانونية أو معتمدة رسميًا ما لم يُذكر ذلك صراحةً لمشروع محدد وتنفذ من قبل مختص مؤهل تأهيلاً مناسبًا.",
        ],
      },
      {
        heading: "4. لا ضمان للقبول",
        paragraphs: [
          "لا نضمن قبول أي ترجمة من قبل المحاكم أو الهيئات الحكومية أو سلطات الهجرة أو المؤسسات التعليمية أو البنوك أو أي طرف ثالث آخر، ما لم يتم تأكيد متطلبات التأهيل المحددة مسبقًا وتم ترتيب العمل لتلبيتها.",
        ],
      },
      {
        heading: "5. عوامل جودة الترجمة الشفوية",
        paragraphs: [
          "يمكن أن تتأثر جودة الترجمة الشفوية بعوامل خارجة عن سيطرتنا، بما في ذلك جودة الصوت وجودة الاتصال والمصطلحات المتخصصة والمعلومات غير الكاملة والمقاطعات ووتيرة تحدث المشاركين أو وضوحهم. يساعدنا تقديم المواد والمسارد والسياق مسبقًا في تقديم أفضل نتيجة ممكنة.",
        ],
      },
      {
        heading: "6. ليست بديلاً عن المشورة المهنية",
        paragraphs: [
          "لا تحل الترجمة التجارية العامة التحريرية والشفوية محل المشورة القانونية أو الطبية أو غيرها من المشورة المهنية المنظمة. تُقدَّم الترجمة القضائية أو القانونية أو الطبية أو غيرها من الترجمات المنظمة أو المتخصصة فقط حيثما تم الاتفاق عليها مسبقًا على وجه التحديد وكان المزود مستوفيًا للمتطلبات المعمول بها.",
        ],
      },
    ],
  },
  website: {
    title: "إخلاء مسؤولية خدمات المواقع الإلكترونية",
    path: "/website-disclaimer",
    sections: [
      {
        heading: "1. ملكية المحتوى والأذونات",
        paragraphs: [
          "العميل مسؤول عن امتلاك أو الحصول على إذن لاستخدام جميع المحتويات المقدمة لمشروع الموقع الإلكتروني — بما في ذلك النصوص والصور والشعارات ومقاطع الفيديو والخطوط والعلامات التجارية. يجوز لـ VCK الاعتماد على تأكيد العميل بأن المواد المقدمة مرخصة بشكل صحيح.",
        ],
      },
      {
        heading: "2. النطاقات والاستضافة",
        paragraphs: [
          "ما لم تنص اتفاقية المشروع على خلاف ذلك، تُسجَّل أسماء النطاقات وحسابات الاستضافة باسم العميل وتظل مسؤولية العميل، بما في ذلك التجديدات. يمكننا تنسيق الإعداد والتجديدات كجزء من النطاق المتفق عليه، لكن تسري شروط مسجلي النطاقات ومزودي الاستضافة الخارجيين.",
        ],
      },
      {
        heading: "3. برامج وإضافات وتطبيقات الطرف الثالث",
        paragraphs: [
          "غالبًا ما تعتمد المواقع الإلكترونية على منصات وقوالب وإضافات وتطبيقات طرف ثالث. وهي خارجة عن السيطرة المباشرة لـ VCK: قد تتغير أو تُحدَّث أو تتوقف أو تحتوي على ثغرات أو تصبح غير متوافقة بمرور الوقت.",
        ],
      },
      {
        heading: "4. التجارة الإلكترونية ومعالجو الدفع",
        paragraphs: [
          "تتم معالجة المدفوعات عبر الإنترنت من قبل مزودين خارجيين (على سبيل المثال، Stripe). تسري شروط هؤلاء المزودين ورسومهم وممارسات الأمان والتوفر الخاصة بهم، ولا تتحمل VCK المسؤولية عن انقطاعاتهم أو قراراتهم أو إجراءاتهم المتعلقة بالحسابات.",
        ],
      },
      {
        heading: "5. حدود الأمان",
        paragraphs: [
          "نتبع ممارسات أمنية معقولة عند بناء المواقع الإلكترونية وصيانتها، لكن لا يمكن لأي موقع إلكتروني أن يكون آمنًا تمامًا أو دون انقطاع أو خاليًا من الأخطاء. الأمان مسؤولية مشتركة ومستمرة تشمل حفاظ العميل على أمان حساباته وبيانات اعتماده.",
        ],
      },
      {
        heading: "6. النسخ الاحتياطية",
        paragraphs: [
          "تعتمد ترتيبات النسخ الاحتياطي على المنصة والنطاق المتفق عليه. ما لم تكن الصيانة المستمرة بما في ذلك النسخ الاحتياطية جزءًا من اتفاقيتك، فإن العميل مسؤول عن الاحتفاظ بنسخه الاحتياطية الخاصة.",
        ],
      },
      {
        heading: "7. تغييرات التوافق",
        paragraphs: [
          "تتطور المتصفحات والأجهزة والمنصات. قد يحتاج الموقع الإلكتروني الذي يعمل اليوم إلى تحديثات ليظل متوافقًا في المستقبل؛ وتقع هذه التحديثات خارج نطاق البناء الأصلي ما لم تكن مشمولة بخطة صيانة.",
        ],
      },
      {
        heading: "8. تصنيفات محركات البحث",
        paragraphs: [
          "نبني المواقع الإلكترونية بممارسات تقنية ومحتوى سليمة، لكننا لا نضمن تصنيفات محركات البحث أو سرعة الفهرسة أو مستويات حركة المرور أو الترتيب لأي كلمة مفتاحية.",
        ],
      },
      {
        heading: "9. إمكانية الوصول والامتثال القانوني",
        paragraphs: [
          "حيثما ينطبق ذلك، يكون العميل مسؤولاً عن إخبارنا بأي متطلبات محددة لإمكانية الوصول أو الخصوصية أو الامتثال التنظيمي لموقعه الإلكتروني (على سبيل المثال، تشريعات إمكانية الوصول أو قواعد الصناعة) حتى يمكن معالجتها في النطاق المتفق عليه. ما لم يكن مشمولاً على وجه التحديد في الاتفاقية، فإن عمليات تدقيق إمكانية الوصول الرسمية ومراجعات الامتثال القانوني ليست جزءًا من بناء الموقع الإلكتروني.",
        ],
      },
      {
        heading: "10. موافقة العميل قبل الإطلاق",
        paragraphs: [
          "تُطلَق المواقع الإلكترونية فقط بعد مراجعة العميل وموافقته. بمجرد الموافقة والإطلاق، تقع مسؤولية المحتوى المنشور على العميل.",
        ],
      },
      {
        heading: "11. الصيانة المستمرة",
        paragraphs: [
          "تُقدَّم التحديثات والمراقبة والصيانة بعد الإطلاق فقط عندما تكون مشمولة في اتفاقية مكتوبة أو خطة دعم شهرية.",
        ],
      },
    ],
  },
  refund: {
    title: "سياسة الدفع والإلغاء والاسترداد",
    path: "/refund-policy",
    sections: [
      {
        heading: "1. هيكل الدفع",
        bullets: [
          "قد تتطلب المشاريع الصغيرة الدفع الكامل قبل بدء العمل.",
          "قد تتطلب المشاريع الأكبر دفعة مقدمة مع مدفوعات مرحلية ونهائية كما هو موضح في عرض السعر أو الاتفاقية.",
          "تُصدر فواتير خطط الدعم الشهرية مسبقًا لكل فترة فوترة.",
          "تتم المدفوعات عبر رابط دفع آمن ترسله لك VCK Business Lab مباشرة بعد تأكيد الخدمة والنطاق والسعر — ولا يوفر هذا الموقع صفحة دفع عامة.",
          "قد يتطلب العمل ذو الأولوية أو العاجل أو الطارئ دفعًا مسبقًا.",
        ],
      },
      {
        heading: "2. الدفعات المقدمة",
        paragraphs: [
          "تحجز الدفعات المقدمة الوقت والموارد لمشروعك. إلى الحد الذي يسمح به القانون، قد تصبح الدفعة المقدمة غير قابلة للاسترداد بمجرد بدء العمل.",
        ],
      },
      {
        heading: "3. العمل المنجز والوقت المنقضي",
        paragraphs: [
          "العمل المنجز والوقت الذي تم أداؤه بالفعل غير قابلين للاسترداد عمومًا، لأنه لا يمكن إرجاعهما.",
        ],
      },
      {
        heading: "4. إذا ارتكبنا خطأً جوهريًا",
        paragraphs: [
          "إذا ارتكبت VCK خطأً جوهريًا في العمل المسلَّم، يرجى إخطارنا على الفور. مع مراعاة القانون المعمول به، يجب أن تحصل VCK أولاً على فرصة معقولة لتصحيح أو إعادة أداء العمل المتأثر قبل السعي للاسترداد أو سبل الانتصاف الأخرى.",
        ],
      },
      {
        heading: "5. الإلغاءات",
        paragraphs: [
          "قد تختلف شروط الإلغاء حسب الخدمة واتفاقيتك الموقعة. بالنسبة لخطط الدعم الشهرية، يسري الإلغاء كما هو موضح في اتفاقيتك — عادةً في نهاية فترة الفوترة الحالية المدفوعة مسبقًا — ولا تُسترد المبالغ التي تم إصدار فواتير بها عن الفترة الحالية ما لم يقتضِ القانون ذلك أو تنص اتفاقيتك على خلافه.",
        ],
      },
      {
        heading: "6. نفقات الطرف الثالث",
        paragraphs: [
          "نفقات الطرف الثالث والتكاليف التي تم تكبدها بالفعل نيابة عنك (على سبيل المثال، النطاقات أو تراخيص البرامج أو المواد الجاهزة أو العمل المنجز من الباطن) غير قابلة للاسترداد عمومًا.",
        ],
      },
      {
        heading: "7. حقوقك الإلزامية",
        paragraphs: [
          "لا يلغي أي شيء في هذه السياسة أو يحد من أي حقوق إلزامية للمستهلك تتمتع بها بموجب القانون المعمول به. حيثما تمنحك تلك القوانين حقوقًا إضافية، تظل سارية.",
        ],
      },
    ],
  },
  cookies: {
    title: "سياسة ملفات تعريف الارتباط",
    path: "/cookie-policy",
    sections: [
      {
        heading: "1. ما هي ملفات تعريف الارتباط",
        paragraphs: [
          "ملفات تعريف الارتباط هي ملفات نصية صغيرة تُخزَّن على جهازك عند زيارة موقع إلكتروني. تساعد المواقع الإلكترونية على العمل وتذكر التفضيلات وفهم كيفية استخدام الموقع.",
        ],
      },
      {
        heading: "2. ملفات تعريف الارتباط التي نستخدمها",
        bullets: [
          "ملفات تعريف الارتباط الأساسية — مطلوبة لعمل الموقع الإلكتروني (على سبيل المثال، ملفات الأمان وموازنة الحمل من منصة الاستضافة لدينا).",
          "ملفات تعريف الارتباط الوظيفية — تتذكر الخيارات التي تحددها، مثل لغة الموقع المفضلة لديك.",
          "ملفات تعريف الارتباط التحليلية — قد تُستخدم لفهم مجمَّع لكيفية استخدام الزوار للموقع حتى نتمكن من تحسينه.",
          "تكاملات الطرف الثالث — قد تضع بعض الخدمات المدمجة أو المرتبطة (مثل أدوات الجدولة أو الدفع أو المراسلة) ملفات تعريف ارتباط خاصة بها عند تفاعلك معها، وفقًا لسياسات الخصوصية الخاصة بها.",
        ],
      },
      {
        heading: "3. كيفية التحكم في ملفات تعريف الارتباط",
        paragraphs: [
          "يمكنك التحكم في ملفات تعريف الارتباط أو حذفها من خلال إعدادات المتصفح في أي وقت، وتتيح لك معظم المتصفحات حظر ملفات تعريف الارتباط تمامًا أو تنبيهك قبل تخزينها. حيثما يوفر الموقع أداة لتفضيلات ملفات تعريف الارتباط، يمكنك أيضًا إدارة الملفات غير الضرورية هناك. قد يؤثر حظر بعض ملفات تعريف الارتباط على عمل أجزاء من الموقع الإلكتروني.",
        ],
      },
      {
        heading: "4. التغييرات على هذه السياسة",
        paragraphs: [
          "قد نحدّث سياسة ملفات تعريف الارتباط هذه مع تطور الموقع الإلكتروني. ستُنشر النسخة الحالية دائمًا على هذه الصفحة مع تاريخ \"آخر تحديث\".",
        ],
      },
    ],
  },
  accessibility: {
    title: "بيان إمكانية الوصول",
    path: "/accessibility",
    sections: [
      {
        heading: "1. التزامنا",
        paragraphs: [
          "تهدف VCK Business Lab إلى جعل موقعها الإلكتروني قابلاً للاستخدام ومتاحًا لأكبر عدد ممكن من الأشخاص، بما في ذلك الأشخاص الذين يستخدمون التقنيات المساعدة. نتعامل مع إمكانية الوصول كجهد مستمر وليس مشروعًا لمرة واحدة.",
        ],
      },
      {
        heading: "2. نرحب بملاحظاتك",
        paragraphs: [
          "إذا واجهت صعوبة في استخدام أي جزء من هذا الموقع الإلكتروني، أو لديك اقتراحات من شأنها أن تجعله أكثر سهولة بالنسبة لك، يرجى التواصل معنا على office@vckbusinesslab.com. سنراجع ملاحظاتك وسنحاول إجراء تحسينات معقولة.",
        ],
      },
      {
        heading: "3. جهد بحسن نية",
        paragraphs: [
          "يعكس هذا البيان التزامنا بحسن نية تجاه إمكانية الوصول. نحن لا ندعي شهادة WCAG رسمية أو امتثالاً كاملاً لأي معيار محدد، ونقدّر الفرصة للتحسين.",
        ],
      },
    ],
  },
  newcomer: {
    title: "إخلاء مسؤولية دعم القادمين الجدد",
    path: "/newcomer-disclaimer",
    sections: [
      {
        heading: "1. نطاق خدمات دعم القادمين الجدد",
        paragraphs: [
          "تقدم VCK Business Lab خدمات دعم عامة تشمل الدعم الإداري واللغوي والترجمة والترجمة الفورية والتنسيق والدعم العملي.",
        ],
      },
      {
        heading: "2. لا استشارات في الهجرة أو المواطنة",
        paragraphs: [
          "لا تقدم VCK Business Lab استشارات أو تمثيلًا في شؤون الهجرة أو المواطنة، ولا تعمل بصفتها مستشار هجرة أو محامي هجرة.",
          "لا نقدم للعملاء مشورة بشأن الأهلية للهجرة أو برامج الهجرة أو استراتيجيات التأشيرات أو التصاريح أو طلبات الإقامة الدائمة أو طلبات الجنسية أو كيفية تعبئة طلبات الهجرة.",
        ],
      },
      {
        heading: "3. لا استشارات مهنية أخرى خاضعة للتنظيم",
        paragraphs: [
          "كما لا نقدم استشارات قانونية أو ضريبية أو مالية أو طبية أو تعليمية أو متعلقة بالتوظيف أو غيرها من الاستشارات المهنية الخاضعة للتنظيم.",
        ],
      },
      {
        heading: "4. الإحالة إلى مختصين مرخصين",
        paragraphs: [
          "عندما يحتاج العميل إلى خدمات مهنية خاضعة للتنظيم، قد توصي VCK Business Lab العميل بالتواصل مع مختص مرخص مناسب.",
          "لا ينبغي تفسير المساعدة الإدارية واللغوية التي تقدمها VCK Business Lab على أنها استشارة مهنية أو تمثيل.",
        ],
      },
      {
        heading: "5. التواصل",
        paragraphs: [
          "VCK Business Lab — إدمونتون، ألبرتا، كندا",
          "البريد الإلكتروني: office@vckbusinesslab.com • الهاتف: +1 587 385 6058 • الموقع: vckbusinesslab.com",
        ],
      },
    ],
  },
};

export const LEGAL_LINKS_AR = [
  { key: "privacy", label: "سياسة الخصوصية" },
  { key: "terms", label: "شروط الاستخدام" },
  { key: "service", label: "شروط الخدمة" },
  { key: "translation", label: "إخلاء مسؤولية الترجمة" },
  { key: "website", label: "إخلاء مسؤولية خدمات المواقع" },
  { key: "refund", label: "سياسة الدفع والاسترداد" },
  { key: "cookies", label: "سياسة ملفات تعريف الارتباط" },
  { key: "accessibility", label: "إمكانية الوصول" },
  { key: "newcomer", label: "إخلاء مسؤولية دعم القادمين الجدد" },
];
